import React from 'react';

export default function NotFoundPageComponent() {
  return <div className="notFoundPage">404</div>;
}
